<lib-dialog-layout>
    <h3 title i18n="@@CommonAddPaymentSourcePaymentProcessorError">
        Payment Processor Error
    </h3>
    <div content class="d-flex flex-column gap-3">
        @if (data.IsProcessorError) {
            <p i18n="@@CommonAddPaymentSourcePaymentProcessorErrorDescription">
                The payment processor returned the following message:
            </p>
        }
        <p>{{ data.ErrorMessage }}</p>
        <p i18n="@@CommonPaymentSourcePaymentProcessorErrorText">
            Please check your payment details or use a different payment method and try again.
        </p>
    </div>
    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
            <lib-button
            [role]="ButtonRole.Primary"
                [kind]="ButtonKind.NeutralSecondary"
                (clicked)="PrimaryAction()">
                <div label i18n="@@CommonClose">
                    Close
                </div>
            </lib-button>
        </lib-submission-bar>
    </ng-container>
</lib-dialog-layout>
